import Type from "../components/Type"

function Home() {
  return (
    <div>
     <Type />
    </div>
  )
}

export default Home
